import Picture from "@/components/common/Picture";
import ZoomImage from "@/components/common/ZoomImage";
import { ImageDisplayVariant } from "@/constants/media";
import type { ExtendedUploadedImage } from "@/types";

export interface DynamicPictureProps {
  image: ExtendedUploadedImage;
  option: ImageDisplayVariant;
}

export default function DynamicPicture(props: DynamicPictureProps) {
  const { image, option } = props;
  const mediaContent = <Picture imageConfig={image} baseBorderRadius />;

  return option === ImageDisplayVariant.Overlay ? (
    <ZoomImage>{mediaContent}</ZoomImage>
  ) : (
    mediaContent
  );
}
